import React from 'react';
import styles from '../Attachment.module.scss';
import { AttachmentNameDisplay } from './GenerticAttachment';
import { useTypedDispatch } from '../../../../redux/hooks';
import { nebulaChatApi } from '../../../../redux/services/nebulaChat';
import { setFilePreview } from '../../../../redux/slices';
import { IFile } from '../../../../types';
import LoadingSpinner from '../../../../components/loading/LoadingSpinner';

interface Props {
    file: IFile;
}

export const PdfAttachment: React.FC<Props> = ({ file }) => {
    const dispatch = useTypedDispatch();
    const [fetchPdf] = nebulaChatApi.endpoints.pullFileN.useLazyQuery();

    const activatePreview = async (e: React.MouseEvent) => {
        e.stopPropagation();
        const result = await fetchPdf({ file_uuid: file.uuid, thumbnail: false });
        if (!result.data) return;
        dispatch(setFilePreview({
            src: result.data,
            file_name: file.name,
            file_type: 'pdf',
            file_size: file.size,
            shared_by: file.shared_by,
            shared_at: file.shared_at as any,
            uuid: file.uuid,
        }));
    };

    if (file.pending) {
        return (
            <>
                <div className={styles.preview_button_container}>
                    <LoadingSpinner color='mamba' />
                </div>
                <div className={styles.file_content_container}>
                    <AttachmentNameDisplay file={file} />
                </div>
            </>
        );
    }

    return (
        <>
            <button onClick={activatePreview} className={styles.pdf}>
                <mark>PDF</mark>
            </button>
            <div className={styles.file_content_container}>
                <AttachmentNameDisplay file={file} />
            </div>
        </>
    );
};
